import React, { Fragment, useState } from "react";
import { Button, Card, CardBody, Col, CardFooter, Row } from "reactstrap";
import TransitionOnLoad from "Components/TransitionOnLoad";
import PageHeading from "Layout/AppMain/PageHeading";
import { DropdownList } from "react-widgets/cjs";
import moment from "moment";
import ReactTableGeneric from "Components/ReactTableGeneric";
import Loader from "react-loaders";
import { usePersonLogs, useCommunityContractList } from "Api/Common/LogPersoonsgegevens";
import { usePlatforms } from "Api/Common/LogboekLogin";



const LogPersoonsgegevens = () => {
    const [selectedCommunity, setSelectedCommunity] = useState('Alle besturen');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selectedPlatform, setSelectedPlatform] = useState('Alle platforms');

    const platforms = [
        "Alle platforms",
        "Web",
        "App",
    ];

    const {
        data: personLogsResponse,
        isLoading,
        mutate,
    } = usePersonLogs(selectedCommunity,
        selectedPlatform === "Alle platforms" ? null : selectedPlatform);

    const logs = personLogsResponse?.data || [];
    const totalCount = personLogsResponse?.total || []


    const {
        data: communityResponse,
        isLoading: communityLoading,
    } = useCommunityContractList();

    const communities = [
        {
            iCommunityId: "all",
            vCommunityName: "Alle besturen",
        },
        ...(communityResponse?.communities || []),
    ];


    const columns = [
        {
            header: 'Datum-Tijd',
            accessorKey: 'created_at',
            cell: ({ row }) =>
                moment(row.original.created_at).format('DD-MM-YYYY HH:mm:ss'),
        },
        {
            header: 'Naam uitvoerder - Clooser-id',
            accessorKey: 'performed_naam_clooser_id',
        },
        {
            header: 'Organisatie',
            accessorKey: 'vCommunityName',
        },
        {
            header: 'Naam betrokkene',
            accessorKey: 'affected_naam_clooser_id',
        },
        {
            header: 'Actie',
            accessorKey: 'vAction',
        },
        {
            header: 'Type',
            accessorKey: 'vType',
        },
        {
            header: 'Soort',
            accessorKey: 'vCategory',
            enableSorting: false,
        },
        {
            header: 'Waarde',
            accessorKey: 'vValue',
            enableSorting: false,
        },
        {
            header: 'Platform',
            accessorKey: 'vPlatform',
            enableSorting: false,
        },
    ];

    if (isLoading) {
        return (
            <Loader
                type="ball-grid-pulse"
                className="mt-3 d-flex mx-auto justify-content-center"
            />
        );
    }

    return (
        <Fragment>
            <PageHeading />
            <TransitionOnLoad>
                <Row>
                    <Col md="12">
                        <Card className="main-card mb-3">
                            <CardBody className="p-3">
                                <ReactTableGeneric
                                    data={logs}
                                    columns={columns}
                                    filters={{
                                        search: true,
                                        pagination: true,
                                        sorting: true,
                                    }}
                                    tableClassName="mb-0 table table-sm table-hover table-borderless color-white"
                                    count={totalCount}
                                />
                            </CardBody>

                        </Card>
                    </Col>
                </Row>
            </TransitionOnLoad>
            <div className="chat-layout-footer">
                <CardFooter className="chat-layout-footer__inner gebruikers-footer">
                    <div className="d-flex gap-3 mr-4">
                        <div className="footer-field-min-width d-flex flex-row gap-2 ">
                            <DropdownList
                                data={communities}
                                dataKey="iCommunityId"
                                textField="vCommunityName"
                                placeholder="Alle besturen"
                                value={
                                    communities.find(
                                        c => c.vCommunityName === selectedCommunity
                                    ) || null
                                }
                                onChange={(community) =>
                                    setSelectedCommunity(community?.vCommunityName ?? "")
                                }
                                filter="contains"
                                dropUp
                            />
                        </div>
                        <div style={{ width: '150px' }}>

                            <DropdownList
                                data={platforms}
                                value={selectedPlatform}
                                onChange={setSelectedPlatform}
                                placeholder="Alle platforms"
                                filter="contains"
                                dropUp
                            />
                        </div>
                    </div>
                </CardFooter>
            </div>
        </Fragment >
    );
};

export default LogPersoonsgegevens;